import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { TimeTrackerComponent } from '../../config';
import { isTimeTrackerComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class TimeTrackerFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<TimeTrackerComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent, reservedIds: Array<string>): boolean {
    const isReserved = !!reservedIds.find(id => id === component.id);
    return !isReserved && isTimeTrackerComponent(component);
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }
}
